export const getters = {
    getCrmProposta: state => state.crmProposta,
    getCrmPropostas: state => state.crmPropostas,
    getModalCadastroCrmProposta: state => state.modalCadastroCrmProposta,
    getModalVisualizarCrmProposta: state => state.modalVisualizarCrmProposta,
    getModalExcluirCrmProposta: state => state.modalExcluirCrmProposta,
    getModalPesquisarCrmProposta: state => state.modalPesquisarCrmProposta,
    getModalFinalizarCrmProposta: state => state.modalFinalizarCrmProposta,
    getCrmPropostaStatus: state => state.crmPropostaStatus
}

export default {}